import React from 'react';

import NumberFormatter from '../../lib/numberFormatter';
import customNumber from '../../lib/customNumberFormatter';
import './NumberWidget.scss';

class NumberWidget extends React.Component {

    constructor(props) {
        super(props);

        this.getSuffix = this.getSuffix.bind(this);
    }
    getSuffix() {
        const { currency, widget } = this.props;
        if (_.includes(['totalVisits', 'topLeadSourceVisits', 'topViewsVisits'], widget.dataType)) {
            return 'Besök';
        } else if (_.includes(['emailSent', 'forms'], widget.dataType)) {
            return 'st';
        } else {
            return currency;
        }

    }

    render() {
        const { widget, widgetData, currency, isThumbnail } = this.props;

        if (isThumbnail) {
            return (<div className={className}></div>);
        }

        let value = 0;
        let budget = 0;

        if (widget && widgetData.length > 0) {
            let totalValue = 0;
            let totalBudget = 0;

            for (let i = 0; i < widgetData.length; i++) {
                totalValue += widgetData[i].value;
                totalBudget += widgetData[i].budget;
            }

            const preValue = Math.floor(totalValue);
            const preBudget = Math.floor(totalBudget);

            if (preValue.toString().length > 6) {
                value = NumberFormatter.shortenLargeNumber(preValue, 2);
                budget = NumberFormatter.shortenLargeNumber(preBudget, 2);
            } else {
                value = customNumber.fixThousands(preValue);
                budget = customNumber.fixThousands(preBudget);
            }
        }

        const percent = (value / budget) * 100;

        let className = '';

        if (percent >= 100) {
            className = 'budget_achieved_numberwidget';
        }

        // TODO: make an option for setting suffix or something.
        value = `${value} ${this.getSuffix(widget)}`;

        const style = {
            fill: '#ffffff',
            fontWeight: 500,
        };

        return (
            <div className={className}>
                <i className="fa fa-check" />
                <svg
                    viewBox="0 -50 85 20"
                    preserveAspectRatio="xMidYMid meet"
                    width="100%"
                    height="100%"
                    style={style}
                >
                    <text
                        dy="-33"
                        dx="-57.5"
                        y="0"
                        x="100"
                        width="100"
                        height="100"
                        textAnchor="middle"
                        style={{fontSize: `${(Math.min(-2.5 * value.length + 110, 100))}%`}}
                    >
                        {value}
                    </text>
                </svg>
            </div>
        );
    }
}

NumberWidget.propTypes = {
    widget: React.PropTypes.object.isRequired,
    widgetData: React.PropTypes.array,
    currency: React.PropTypes.string,
};

export default NumberWidget;



/** WEBPACK FOOTER **
 ** ./client/components/Widgets/NumberWidget.jsx
 **/